import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var deleteConnectedAccount = mutatorAction('deleteConnectedAccount', function (selected) {
    var store = connectedAccountsStore();
    var accounts = [];
    var index = 0;
    for (index = 0; index < store.accounts.length; index++) {
        if (index !== selected) {
            accounts.push(store.accounts[index]);
        }
    }
    store.accounts = accounts;
    store.selected = -1;
});
//# sourceMappingURL=deleteConnectedAccount.js.map